const WEEKDAY = new Intl.DateTimeFormat('de-DE', { weekday: 'long' })
const DAY_MONTH = new Intl.DateTimeFormat('de-DE', { day: 'numeric', month: 'long' })

export interface DayStripParts {
  /** `Montag` */
  weekday: string
  /** `26. Oktober` */
  date: string
  /** `2026` */
  year: string
}

/**
 * The one date the day view names, in words and never abbreviated.
 *
 * Returned as parts, not one string, so the strip can weight the weekday and fade the year without
 * parsing its own output.
 */
export function formatDayStrip(date: Date): DayStripParts {
  return {
    weekday: WEEKDAY.format(date),
    date: DAY_MONTH.format(date),
    year: String(date.getFullYear()),
  }
}
